import { charactersBlueIcon } from 'utils/icon/icon_characters-blue.svg';
import { COMMON, kevinAuthAPI } from 'apis/config';

//** 에피소드 API */

import { ifyouApi, STORY } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';
import { IDropListProps } from 'utils/types/common';

export const episodeApi = {
  read: (lang: string, projectId: string | undefined) =>
    ifyouApi
      .post(`${STORY}/${projectId}/episode-list-new`, {
        lang: lang,
      })
      .then((res) => res.data.map((v, i) => ({ ...v, key: i })))
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  list: (projectId: string | undefined) =>
    kevinAuthAPI
      .get(`${STORY}/${projectId}/episode`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  connectEpisodeList: (projectId: string | undefined, dlcId: string) =>
    kevinAuthAPI
      .get(`${COMMON}/project/${projectId}/episode/${dlcId}`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  updateEpisodeBanner: (
    projectId: string | undefined,
    episodeId: string,
    file: any,
  ) => {
    const formData = new FormData();
    formData.append('file', file);
    return kevinAuthAPI
      .patch(`${STORY}/${projectId}/episode/${episodeId}/banner`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      });
  },
  updateEpisodeDetail: (lang: string, projectId: string, data: any) => {
    return kevinAuthAPI
      .put(`${STORY}/${projectId}/${lang}/episode`, data)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      });
  },
  couponList: (projectId: string | undefined, dlcId: string) =>
    kevinAuthAPI
      .get(`${COMMON}/project/${projectId}/coupon/${dlcId}`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  episodeStatus: (lang: string) =>
    kevinAuthAPI
      .get(`${COMMON}/localize/episode_status?lang=${lang}`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  unlockCondition: (lang: string) =>
    kevinAuthAPI
      .get(`${COMMON}/localize/unlock_style?lang=${lang}`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  charactersList: (projectId: string, dlcId: string) =>
    kevinAuthAPI
      .get(`${COMMON}/project/${projectId}/character/${dlcId}`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  fetchDetail: (projectId, episodeId) =>
    ifyouApi
      .post(`${STORY}/${projectId}/episode-detail`, {
        episode_id: episodeId,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  register: (projectId, inputDatas) =>
    kevinAuthAPI
      .post(`${STORY}/${projectId}/episode`, {
        title: inputDatas.title,
        episode_type: inputDatas.episode_type,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  update: (projectId, episodeId, detailData, langList) =>
    ifyouApi
      .post(`${STORY}/${projectId}/episode-update`, {
        episode_id: episodeId,
        episode_type: detailData.episode_type,
        price: detailData.price,
        ending_type: detailData.ending_type,
        episode_status: detailData.episode_status,
        depend_episode: detailData.depend_episode,
        unlock_style: detailData.unlock_style,
        unlock_episodes: detailData.unlock_episodes,
        unlock_scenes: detailData.unlock_scenes,
        unlock_coupon: detailData.unlock_coupon,
        sale_price: detailData.sale_price,
        square_image_id: detailData.square_image_id,
        popup_image_id: detailData.popup_image_id,
        currency: detailData.currency,
        one_currency: detailData.one_currency,
        one_price: detailData.one_price,
        first_reward_currency: detailData.first_reward_currency,
        first_reward_quantity: detailData.first_reward_quantity,
        first_reward_exp: detailData.first_reward_exp,
        publish_date: detailData.publish_date,
        next_open_min: Number(detailData.next_open_min),
        open_decrease_rate: Number(detailData.open_decrease_rate),
        speaker: detailData.speaker,
        langList: langList,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  delete: (projectId, episodeId) =>
    kevinAuthAPI
      .delete(`${STORY}/${projectId}/episode/${episodeId}`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  sorting: (projectId, rows) =>
    kevinAuthAPI
      .post(`${STORY}/${projectId}/episode/sort`, {
        episodes: rows,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  selectionConfirm: (lang, projectId, rows) =>
    ifyouApi
      .post(`${STORY}/${projectId}/episode-selection-all`, {
        rows: rows,
        lang: lang,
      })
      .then((res) => res.data),
};

export const fetchDropEpisode = {
  episodePopThumbnail: (projectId: string) =>
    ifyouApi
      .post(`${STORY}/${projectId}/com-design-select`, {
        design_type: 'episode_big',
      })
      .then((res) => res.data.map((v, i) => ({ ...v, key: i }))),
  unLockList: () =>
    ifyouApi
      .post(`${COMMON}`, { func: 'standard', code: 'unlock_style' })
      .then((res) =>
        res.data.map((v, i) => ({
          ...v,
          text: v.code_name,
          value: v.code,
          key: i,
        })),
      ),
  episodeUnlockList: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'targetProjectEpisodeUnlock',
        project_id: `${projectId}`,
      })
      .then((res) => {
        const newArr: IDropListProps[] = [];
        res?.data?.map((v, i) =>
          newArr.push({ key: i, value: v.episode_id, text: v.title }),
        );
        return newArr;
      }),
  sceneIdList: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'targetProjectSceneUnlock',
        project_id: `${projectId}`,
      })
      .then((res) => {
        const newArr: IDropListProps[] = [];
        res?.data?.map((v, i) =>
          newArr.push({ key: i, value: v.scene_id, text: v.title }),
        );
        return newArr;
      }),
  couponList: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'targetCouponUnlock',
        project_id: `${projectId}`,
      })
      .then((res) => {
        const newArr: IDropListProps[] = [];
        res.data?.map((v, i) =>
          newArr.push({ key: i, value: v.group_code, text: v.group_name }),
        );
        return newArr;
      }),
};
